var chunkMapping = {
	"0": [
		4674
	],
	"3": [
		4071,
		4606
	],
	"79": [
		5110
	],
	"164": [
		5197
	],
	"165": [
		5198
	],
	"168": [
		5201
	],
	"169": [
		5202
	],
	"170": [
		5203
	],
	"171": [
		5204
	],
	"172": [
		5205
	],
	"173": [
		5206
	],
	"174": [
		5207
	],
	"175": [
		5208
	],
	"176": [
		5209
	],
	"177": [
		5210
	],
	"178": [
		5211
	],
	"179": [
		5212
	],
	"180": [
		5213
	],
	"181": [
		5214
	],
	"182": [
		5215
	],
	"183": [
		5216
	],
	"184": [
		5217
	],
	"185": [
		5218
	],
	"186": [
		5219
	],
	"187": [
		5220
	]
};
var idToExternalAndNameMapping = {
	"4071": [
		"default",
		"./nuorder-components",
		3687
	],
	"4606": [
		"default",
		"./helios-components",
		3687
	],
	"4674": [
		"default",
		"./Containers",
		3597
	],
	"5110": [
		"default",
		"./OrderlessInvoices",
		3597
	],
	"5197": [
		"default",
		"./AsyncEventTracker",
		3597
	],
	"5198": [
		"default",
		"./HostWrapper",
		3597
	],
	"5201": [
		"default",
		"./CheckoutV3",
		3597
	],
	"5202": [
		"default",
		"./CheckoutConfirmation",
		3597
	],
	"5203": [
		"default",
		"./ContactCreditCards",
		3597
	],
	"5204": [
		"default",
		"./AuditDialog",
		3597
	],
	"5205": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3597
	],
	"5206": [
		"default",
		"./InvoiceDialog",
		3597
	],
	"5207": [
		"default",
		"./PaymentDueModal",
		3597
	],
	"5208": [
		"default",
		"./PaymentModal",
		3597
	],
	"5209": [
		"default",
		"./PaymentHistory",
		3597
	],
	"5210": [
		"default",
		"./PaymentConfigurations",
		3597
	],
	"5211": [
		"default",
		"./PaymentPreferences",
		3597
	],
	"5212": [
		"default",
		"./ManagePaymentProcessing",
		3597
	],
	"5213": [
		"default",
		"./MobilePaymentsWrapper",
		3597
	],
	"5214": [
		"default",
		"./PayPage",
		3597
	],
	"5215": [
		"default",
		"./Challenge",
		3597
	],
	"5216": [
		"default",
		"./ManagePaymentMethods",
		3597
	],
	"5217": [
		"default",
		"./LightspeedReports",
		3597
	],
	"5218": [
		"default",
		"./ActivateLightspeedPayments",
		3597
	],
	"5219": [
		"default",
		"./MarketingLandingPage",
		3597
	],
	"5220": [
		"default",
		"./ShippingPromotionsListContainer",
		3597
	]
};
var idToRemoteMap = {
	"4071": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4606": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4674": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5110": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5201": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5202": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5203": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5204": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5205": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5206": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5209": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5210": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5212": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5214": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5217": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5218": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5219": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}